import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, AbstractControl, Validators } from '@angular/forms';
import { UserService } from '../../../../services/user.service';
import { MatSnackBar, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm:FormGroup;

  constructor(private formBuilder:FormBuilder, 
    private userService:UserService, private snackBar:MatSnackBar, 
    @Inject (MAT_DIALOG_DATA) private data:any) { 
    this.changePasswordForm = this.formBuilder.group({
      password:['',[Validators.required]],
      confirmPassword:['',[Validators.required]]
    },{
      validator: checkPasswordsMatch()
    })
  }

  ngOnInit() {
  }

  save(){
    /* server expects an array */
    const changePassObj = {
      username: this.data.currentUserUsername,
      newPassword: this.password.value,
      password: this.confirmPassword.value
    }

    this.userService.editUserDetails(changePassObj)
    .subscribe(res=>{
        this.snackBar.open('Password changed', 'success', {duration:4000})
    }, error => {
      this.snackBar.open('Operation failed', 'error', {duration:5000});
    });
  }

  get password(){
    return this.changePasswordForm.get('password');
  }

  get confirmPassword(){
    return this.changePasswordForm.get('confirmPassword');
  }

}

export function checkPasswordsMatch(): ValidatorFn{
  return (control:AbstractControl):{[key:string]:boolean}|null => {

    const password1 = control.get('password').value;
    const password2 = control.get('confirmPassword').value; 

    if(password1 != password2)
      return {'checkPasswordsMatch': true}
    else if(password1 === password2)
      return null;

  }
}
